import React from "react";

/**
 * @component SendFilledIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <SendFilledIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SendFilledIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      data-testid="SendFilledIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M3.953 23.4l17.8-9.641a2 2 0 000-3.518L3.953.6A2 2 0 001 2.358V9l8 3-8 3v6.642a2 2 0 002.953 1.759z"
        fillRule="evenodd"
      />
    </svg>
  )
);
SendFilledIcon.displayName = "SendFilledIcon";
export default SendFilledIcon;
